import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useGoogleSpreadsheetDataImport } from '../../io/GoogleV2Hooks';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const useGoogleSpreadsheetDataImportWidget = () => {
    const { components } = useGoogleSpreadsheetDataImport({
        provideImportButton: true,
    });
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "ImportButton" }), components.ImportButton, _jsx(Typography, { variant: "h5", children: "WorkingSpinner" }), components.WorkingSpinner] })), [components]);
    return {
        name: 'useGoogleSpreadsheetDataImport',
        category: 'composite',
        component,
    };
};
